import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authenticateAction, registerAction } from "../ImageCapture/ImageCaptureSlice";
import { RootState } from "../../redux";
import { confirmContactInfoAPI, getContactInfo } from "./ContactInfoApi";
import type { AddressChangeInfo } from "../Address/types";
import type { OriginalInfo, UpdatedConactInfo } from "../../types";

export interface ContactInfoState {
  regNum: number | null;
  contactInfo: OriginalInfo | null;
  email: string | null;
  phone: string | null;
  address: AddressChangeInfo | null;
  isUpdatedAddress: boolean;
}

const initialState: ContactInfoState = {
  regNum: null,
  // regNum:9138013,
  contactInfo: null,
  email: "",
  phone: "",
  address: null,
  isUpdatedAddress: false,
};

export const getContactInfoAction = createAsyncThunk(
  "getContactInfoAction",
  async (args: { regNum: number; lan: string }) => {
    const response = await getContactInfo(args);
    return response.data;
  }
);

export const confirmContactInfoAction = createAsyncThunk(
  "confirmContactInfoAction",
  async (args: {
    contactInfo: OriginalInfo;
    updatedContactInfo: UpdatedConactInfo;
    paneemEmail: string | null;
    lan: string;
  }) => {
    const response = await confirmContactInfoAPI(args);
    return response.data;
  }
);

export const contactInfoSlce = createSlice({
  name: "contactInfo",
  initialState,
  reducers: {
    setAddress: (state, { payload }: { payload: AddressChangeInfo }) => {
      state.address = payload;
    },

    setEmail: (state, { payload }: { payload: string }) => {
      state.email = payload;
    },
    setPhone: (state, { payload }: { payload: { dialCode: string; phone: string } }) => {
      const { dialCode, phone } = payload;

      const fullPhoneNumber = `${dialCode} ${phone.replace(/^0/, "")}`;
      state.phone = fullPhoneNumber;
    },
    setIsUpdatedAddress: (state) => {
      state.isUpdatedAddress = true;
    },

    resetContactInfoState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getContactInfoAction.fulfilled, (state, { payload }) => {
      const { contactInfo, result } = payload;
      if (!result) {
        state.regNum = null;
        return;
      }
      state.contactInfo = contactInfo;
      state.phone = contactInfo.phone ? contactInfo.phone : "";
      state.email = contactInfo.email ? contactInfo.email : "";

      const address = `${contactInfo.ADD_LINE1}, ${contactInfo.ADD_LINE2 ? contactInfo.ADD_LINE2 : ""} `;

      const city = contactInfo.Claimant_Current_City;
      const countryState = contactInfo.Claimant_Current_State ? contactInfo.Claimant_Current_State : "";
      const country = contactInfo.ISO_Country;
      const zipcode = contactInfo.Claimant_Current_Zip_Code ? contactInfo.Claimant_Current_Zip_Code : "";

      state.address = {
        street: address,
        city,
        state: countryState,
        country,
        zipcode,
        building: "",
        apt: "",
      };
    });

    builder.addCase(confirmContactInfoAction.fulfilled, (state) => {
      state.contactInfo = null;
      state.email = "";
      state.phone = "";
      state.address = null;
    });
    builder.addCase(registerAction.fulfilled, (state, { payload }) => {
      if (payload!.message === "document_back") return;
      else {
        state.regNum = payload!.registrationNumber as number;
      }
    });

    builder.addCase(authenticateAction.fulfilled, (state, { payload }) => {
      state.regNum = payload!.registrationNumber as number;
    });
  },
});

export const { setAddress, setEmail, setPhone, setIsUpdatedAddress, resetContactInfoState } = contactInfoSlce.actions;

export const selectRegNum = (state: RootState) => state.contactInfo.regNum;
export const selectCurrectInfo = (state: RootState) => state.contactInfo.contactInfo;
export const selectAddress = (state: RootState) => state.contactInfo.address;
export const selectPhone = (state: RootState) => state.contactInfo.phone;
export const selectContactEmail = (state: RootState) => state.contactInfo.email;
export const selectIsUpdatedAddress = (state: RootState) => state.contactInfo.isUpdatedAddress;

export default contactInfoSlce.reducer;
